import { render, staticRenderFns } from "./PrivacyImportant.vue?vue&type=template&id=04cd3d92&"
import script from "./PrivacyImportant.vue?vue&type=script&lang=js&"
export * from "./PrivacyImportant.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyImportant.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports